module.exports = __webpack_public_path__ + "img/zhongYao1.bb8c2508.png";